export default __webpack_public_path__ + "static/media/kangaskhan.5842918f.gif";